import React from 'react';
import { FormattedMessage } from 'translations';
import classnames from 'classnames';

import { Layout } from 'app/components/base/Layout';

import style from './style.css';

/**
 * Header notification bar that shows process stage and status.
 * Used in the booking page and confirmation page, Desktop version.
 * It receives either translations keys, or text as string.
 */
const HeaderNotification = ({
  titleId,
  title,
  titleClassName,
  statusId,
  status,
  statusComponent,
  statusClassName,
  primary,
  gray,
}) => {
  if (!titleId && !title) return null;

  const statusModifiers = {
    [style['status-primary']]: primary,
    [style['status-gray']]: gray,
  };

  return (
    <Layout
      className={style.container}
      direction="column"
      size="noshrink"
      nowrap
    >
      <Layout
        className={classnames(style.title, titleClassName)}
        align="center center"
      >
        {titleId && <FormattedMessage id={titleId} />}
        {!titleId && title && <span>{title}</span>}
      </Layout>
      {(statusId || status || statusComponent) && (
        <Layout
          align="center center"
          className={classnames(style.status, statusModifiers, statusClassName)}
        >
          {statusId && <FormattedMessage id={statusId} />}
          {!statusId && status && <span>{status}</span>}
          {statusComponent && React.cloneElement(statusComponent)}
        </Layout>
      )}
    </Layout>
  );
};

// TODO: move to Flow types
// HeaderNotification.propTypes = {
//   titleId: PropTypes.string,
//   title: PropTypes.string,
//   titleClassName: PropTypes.string,
//   statusId: PropTypes.string,
//   status: PropTypes.string,
//   statusComponent: PropTypes.node,
//   statusClassName: PropTypes.string,
//   primary: PropTypes.bool,
//   gray: PropTypes.bool
// };

HeaderNotification.defaultProps = {
  primary: true,
};

export default HeaderNotification;
